module.exports = __webpack_public_path__ + "static/schematic3-e0d7694c4a4ddbef6a020067ed18b1cf.png";